/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RestorePatientProgram$Params {
  patientProgramID?: number;
}

export function RestorePatientProgram(http: HttpClient, rootUrl: string, params?: RestorePatientProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, RestorePatientProgram.PATH, 'post');
  if (params) {
    rb.query('patientProgramID', params.patientProgramID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

RestorePatientProgram.PATH = '/api/Supervisor/RestorePatientProgram';
